module.exports = __webpack_public_path__ + "img/48.cleaner_arrived.5c649f29.svg";